import { el } from 'redom';

import { stringToSVG } from 'utilities';

import closeButtonIconString from 'assets/images/close-button-icon.svg?raw';

const closeButtonIcon = stringToSVG(closeButtonIconString);

class Value {

  constructor(options) {

    this.index = -1;
    this.onRemove = options.onRemove;

    this.label = el('label.multiple-values-input-value-text', {
      class: 'ellipsis'
    });
    this.removeButton = el('button.multiple-values-input-value-remove-button', {
      onclick: this.handleRemoveButtonClick.bind(this)
    }, closeButtonIcon.cloneNode(true));

    this.el = el('.multiple-values-input-value', [this.label, this.removeButton]);

  }

  handleRemoveButtonClick(event) {

    event.stopPropagation();

    this.onRemove(this.index);

    return false;

  }

  update(entry, index) {

    this.index = index;

    this.label.textContent = entry.label;

  }

}

export default Value;